import React from 'react';
import s from './CommonFooter.scss';
import { LinkWrapper } from '../BaseComp';

export const CommonFooter = () => {
    return (
        <div className={s.box}>
            <p className={s.line}>
                <LinkWrapper className={s.link} href="http://pinyin.sogou.com/" rel="nofollow">搜狗输入法</LinkWrapper>
                -
                <LinkWrapper className={s.link} href="http://pay.sohu.com/" rel="nofollow">支付中心</LinkWrapper> - <LinkWrapper className={s.link} href="http://hr.sohu.com/" rel="nofollow">搜狐招聘</LinkWrapper>
                -
                <LinkWrapper className={s.link} href="http://ad.sohu.com/" rel="nofollow">广告服务</LinkWrapper>
                -
                <LinkWrapper className={s.link} href="http://intro.sohu.com/contact" rel="nofollow">联系方式</LinkWrapper>
                -
                <LinkWrapper className={s.link} href="http://investors.sohu.com/" rel="nofollow">About SOHU</LinkWrapper>
                -
                <LinkWrapper className={s.link} href="http://intro.sohu.com/home" rel="nofollow">公司介绍</LinkWrapper>
                -
                <LinkWrapper className={s.link} href="http://intro.sohu.com/privacy" rel="nofollow">隐私政策</LinkWrapper>
            </p>
            <p className={s.line}>
                <span className={s.copyright}>Copyright © {new Date().getFullYear()} Sohu All Rights Reserved. 搜狐公司</span>
                <LinkWrapper className={s.link} href="http://corp.sohu.com/s2007/copyright/" rel="nofollow">版权所有</LinkWrapper>
            </p>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/CommonFooter/index.tsx